"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.purchaseAction = void 0;
const gql_1 = require("../../../gql");
const isomorphic_1 = require("../../../isomorphic");
const models_1 = require("../../../models");
const utils_1 = require("../../../utils");
const auth_1 = require("../../../utils/auth");
const metric_helper_1 = require("../../../utils/metric-helper");
const types_1 = require("../types");
const types_2 = require("./types");
const purchaseAction = (request) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { requestId, asin, tenant, marketplaceId, ubid, sessionId, csrfToken, customerId, subscriptionData, paymentMethodId, cxIdentifier, shouldRedirectUnauthenticatedToAuthPortal = false } = request;
    const methodName = 'actionPurchaseMutation';
    const metricName = 'actionPurchaseMutation';
    const purchaseMutationProps = {
        gqlMutation: gql_1.actionMutation,
        variables: {
            asin,
            tenant,
            actionType: types_1.ActionType.Purchase,
            marketplaceId,
            data: JSON.stringify({
                subscriptionData,
                paymentMethodId,
                cxIdentifier
            }),
            customerId
        },
        headers: {
            [models_1.ShoppingPortalHeadersEnum.MarketplaceId]: marketplaceId,
            [models_1.ShoppingPortalHeadersEnum.UBID]: ubid,
            [models_1.ShoppingPortalHeadersEnum.SessionId]: sessionId,
            [auth_1.AuthHeadersEnum.AntiCsrfToken]: csrfToken,
            [utils_1.HTTPHeaders.RequestId]: requestId
        },
        shouldRedirectUnauthenticatedToAuthPortal
    };
    const startTime = Date.now();
    let mutateMoneraServiceResponseTime;
    let response;
    try {
        response = yield (0, gql_1.mutateMoneraService)(purchaseMutationProps);
    }
    catch (ex) {
        isomorphic_1.LOGGER.error('error executing purchase action: ', ex);
        return {
            status: types_2.PurchaseActionResponseStatus.FAILURE,
            data: undefined,
            error: { name: models_1.ErrorType.UNEXPECTED_ERROR, message: `Error executing purchase action: ${ex.message}` }
        };
    }
    finally {
        mutateMoneraServiceResponseTime = Date.now() - startTime;
        isomorphic_1.LOGGER.info(`Purchase action completed in ${mutateMoneraServiceResponseTime}ms`);
        (0, metric_helper_1.emitLatencyMetrics)(methodName, metricName, mutateMoneraServiceResponseTime, requestId, tenant);
        (0, metric_helper_1.meterFatalsFromResponse)(response, {
            methodName,
            metricName,
            tenant,
            requestId
        });
    }
    if (response === undefined) {
        isomorphic_1.LOGGER.error('error executing purchase action');
        return {
            status: types_2.PurchaseActionResponseStatus.FAILURE,
            data: undefined,
            error: { name: models_1.ErrorType.UNEXPECTED_ERROR, message: 'Response is undefined' }
        };
    }
    else if ((0, models_1.isError)(response)) {
        isomorphic_1.LOGGER.error('error executing purchase action, response: ', response);
        return {
            status: types_2.PurchaseActionResponseStatus.FAILURE,
            data: response.data,
            error: { name: response.name, message: response.message }
        };
    }
    else {
        return {
            status: types_2.PurchaseActionResponseStatus.SUCCESS,
            data: (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.action) === null || _b === void 0 ? void 0 : _b.response
        };
    }
});
exports.purchaseAction = purchaseAction;
